/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import "@babel/polyfill";
import Vue from "vue";
import VeeValidate from "vee-validate";
import Vuex, { mapActions } from "vuex";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import vSelect from "vue-select";
import Notifications from "vue-notification";

import VueInternationalization from "vue-i18n";
import { i18n } from "./lang";

import { Tab, Tabs } from "vue-tabs-component";
import Simplert from "vue2-simplert";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import moment from "moment-timezone";
import VueClipboard from "vue-clipboard2";
import Toasted from "vue-toasted";
import ReportShow from "./components/reports/reports.show.component.vue";
import VueScrollTo from "vue-scrollto";
import router from "./router";
import App from "./App.vue";

import en from "date-fns/locale/en-GB";
import zh from "date-fns/locale/zh-CN";
import { registerLocale } from "react-datepicker";
import { store } from "@/store/store";
import "./assets/theme/_theme.scss";
import { NewReportStore } from "@/store/NewReportStore";
import { CompanyStore } from "@/store/CompanyStore";

registerLocale("en", en);
registerLocale("zh", zh);

Vue.use(Notifications);

Vue.use(BootstrapVue);

// Install the vue plugin

Vue.use(VueScrollTo);

Vue.use(Toasted);

Vue.use(VueClipboard);

Vue.component("tabs", Tabs);
Vue.component("tab", Tab);
Vue.component("simplert", Simplert);

Vue.use(VueInternationalization);

Vue.component("v-select", vSelect);

Vue.use(VeeValidate);
Vue.use(Vuex);
Vue.use(VueRouter);

Vue.component("report-show", ReportShow);
Vue.use(VueSweetalert2);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("dddd, MMMM Do YYYY, hh:mm:ss");
  }
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
  methods: {
    ...mapActions({
      fetchProductInfo: "productStore/fetchInfo",
      fetchCharacteristicUnits: "characteristicsStore/fetchUnits",
      fetchFileCategories: "fileStore/loadFileCategories"
    })
  },
  created() {
    this.fetchCharacteristicUnits();
    if (sessionStorage.getItem("cedoon_user")) {
      this.fetchFileCategories();
      this.fetchProductInfo();
      NewReportStore.getPrintPdfSettings();
      CompanyStore.loadAvailableCompanies();
    }
  }
}).$mount("#app");
